import React from "react";
import './photo.css';

interface PhotoProps{
    /**
     * Variant of photo render
     */
    variant?: 'circle' | 'square',
    /**
     * Photo size
     */
    size?: 'tiny' | 'small' | 'medium' | 'large',
    /**
     * Image URL source
     */
    src: string,
    /**
     * Alternative text for image
     */
    alt?: string
}

/**
 * Photo component
 */
export const Photo = ({
    variant = 'circle',
    size = 'medium',
    alt = '',
    src
}: PhotoProps) => {
    //    return <img src={realImage} ref={ref} alt={alt} className={[variant === 'circle' ? 'rounded-full' : '', size === 'small' ? 'w-[6rem] h-[6rem]' : (size === 'medium' ? 'w-[16em] h-[16em]' : 'w-[24rem] h-[24rem]'), 'object-cover'].join(' ')}/>
    const realImage = src ? (src.startsWith('http') ? src : `https://firebasestorage.googleapis.com/v0/b/dd-asia.appspot.com/o/${src.replaceAll('/', '%2F')}?alt=media`) : undefined;
    return <div className={['photo', 'photo-root', `photo-root--${variant}`, `photo-root--${size}`].join(' ')}>
        <img src={realImage} alt={alt} className={`photo photo-image photo-image--${variant} photo-image--${size} aspect-square`}/>
    </div>
}